<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true" class="assets-success">
  <img src="../../../../assets/icon/asset-success.svg" alt="Assets Success Icon" />
  <h1>{{ (is3a ? 'sp.revamp.overlay.title3a' : 'sp.revamp.overlay.title') | translate}}</h1>
  <p [innerHTML]="(is3a ? 'sp.revamp.overlayDescription3a' : 'sp.revamp.overlayDescription') | translate"></p>
  <button (click)="onAccountDetails()">
    <ion-icon name="account-details"></ion-icon>
    {{ 'sp.reminder.banner.cta.accountDetails' | translate }}
  </button>
  <button *ngIf="isWisher" class="white" (click)="onOpenReminder()">
    <ion-icon name="alarm"></ion-icon>
    {{ (remindAt ? 'sp.reminder.confirmation.cta.change' : 'sp.reminder.banner.cta.set') | translate }}
  </button>
</ion-content>
